<template>
  <div class="ui-padding-main">
    
    <div class="ui-main-container">
      <searchbar :opt="searchbarOpt" @query="search" v-show="issupplier=='true'"></searchbar>
      <searchbartwo :opt="searchbarOptTwo" @query="search2" v-show="issupplier=='false'"></searchbartwo>
      <el-table
        class="ui-table"
        :header-cell-class-name="tableHeaderCellClassName"
        :cell-class-name="tableContentCellClassName"
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        border
      >
        <el-table-column
          prop="rfqnum"
          :label="tableLabel.tenderNo"
         style="width: 12%"
        >
        </el-table-column>
        <el-table-column :label="tableLabel.description" :show-overflow-tooltip="true" style="width: 55%">
          <template slot-scope="scope">
            <div class="flex flex-align-items-center">
              <div class="flex1 line-clamp-2">
                <div class="line-word-break">
                  {{ scope.row.tenderdesc }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="enddate" :label="tableLabel.enddate">
        </el-table-column>
        <!-- <el-table-column
          prop="totalamount"
          :label="tableLabel.totalAmount"
          style="width: 12%"
          :formatter="numFormat"
        >
        </el-table-column> -->
        <el-table-column prop="status" :label="tableLabel.status" style="width: 112%">
        </el-table-column>
        <el-table-column label="" style="width: 12%"  >
          <template slot-scope="scope" v-show="issupplier=='true'">
            <router-link v-show="query.str && issupplier=='true'" 
            :to="'/tenderdetail/' + scope.row.udztbnum +'/' + paginationConfig.total.toString() +'/'+ scope.row.status.toString()+'/'+query.str.toString()"
              class="el-button el-button--primary"
              >{{ buttonLabel.detail }}</router-link
            ><router-link v-show="!query.str && issupplier=='true'"
            :to="'/tenderdetail/' + scope.row.udztbnum +'/' + paginationConfig.total.toString() +'/'+ scope.row.status.toString()"
              class="el-button el-button--primary"
              >{{ buttonLabel.detail }}</router-link
            ><router-link v-show="issupplier=='false'" 
            :to="'/tenderdetail/' + scope.row.udztbnum + '/' + scope.row.suppliername + '/' + scope.row.status.toString() 
            + '/' + scope.row.siteid.toString() + '/' + scope.row.rfqnum.toString()"
              class="el-button el-button--primary"
              >{{ buttonLabel.detail }}</router-link
            >
            </template>
        </el-table-column>
      </el-table>
      <div class="ui-pagination">
        <el-pagination
          background
          :current-page="paginationConfig.page"
          :page-size="paginationConfig.pagesize"
          layout="prev, pager, next"
          :hide-on-single-page="true"
          :total="paginationConfig.total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title :visible.sync="visible">
      <detail-box
        :detail="tenderDetail"
        content-box-style="min-height: 6em; max-height: 50vh"
      ></detail-box>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import searchbar from "../../components/form/SearchBar";
import searchbartwo from "../../components/form/SearchBarTwo";
import detailbox from "../../components/tender/DetailBox";
import { postRequest,token} from "../../utils/api";
export default {
  components: {
    searchbar,
    searchbartwo,
    "detail-box": detailbox
  },
  data() {
    return {
      searchbarOpt: {
        placeholder: this.$t("biddingList_pageText.SEARCHPLACEHOLDER"),
        text: "",
        filter: {
          show: true,
          value: "not in ('')",
          filterList: [
            {
              label: this.$t("biddingList_pageText.ALL"),
              value: "not in ('')"
            },
            {
              label: this.$t("biddingList_pageText.WTQUOTE"),
              value: "in ('WTQUOTE')"
            },
            {
              label: this.$t("biddingList_pageText.COMPQUQTE"),
              value: "in ('SUBMITED')"
            },
            {
              label: "Lost",
              value: "in ('LOST')"
            },
            {
              label: "Awarded",
              value: "in ('AWARDED')"
            },
            {
              label: "Declined",
              value: "in ('DECLINED')"
            },
          ]
        }
      },
      searchbarOptTwo:{
        suppliername:"",
        tenderNo:""
      },
      buttonLabel: {
        more: this.$t("common_pageText.MORE"),
        detail: this.$t("biddingList_pageText.DETAIL")
      },
      tableLabel: {
        tenderNo: this.$t("biddingList_pageText.TENDERNO"),
        description: this.$t("biddingList_pageText.DESCRIPTION"),
        // supplierName: this.$t("biddingList_pageText.SUPPLIERNAME"),
        tenderType: this.$t("biddingList_pageText.TENDERTYPE"),
        tenderTemplate: this.$t("biddingList_pageText.TENDERTEMPLATE"),
        contact: this.$t("biddingList_pageText.CONTACT"),
        enddate: this.$t("biddingList_pageText.ENDDATE"),
        totalAmount: this.$t("biddingList_pageText.TOTALAMOUNT"),
        status: this.$t("biddingList_pageText.STATUS")
      },
      pageText: {
        welcomMsg: 'Welcome to NAN FUNG Supplier Portal',
        loginUser: this.$t("common_pageText.LOGINUSER"),
        MyComPro: 'My Company Profile',
        logout: this.$t("common_pageText.LOGOUT"),
        changepwd: "Change Password",
      },
      tableData: [],
      visible: false,
      tenderDetail: {
        title: {
          label: this.$t("biddingList_pageText.TENDERNO"),
          value: ""
        },
        content: {
          label: "",
          value: ""
        }
      },
      paginationConfig: {
        total: 0,
        pagesize: 10,
        page: 1
      },
      query: {
        reqname: "", //必填，该请求包含（获取所有当前用户的标书、获取不同状态的标书、获取过滤后的标书以及标书详情四个）
        hrid: "", //当前用户，必填
        pagesize: "", //页面大小，必填
        page: "", //页码，必填
        str: "", //必填，搜索框过滤条件，传入代表过滤条件，传入空值，代表所有
        status: "" //用于列表根据状态快速过滤，不传代表获取所有
      },
      loading: false,
      issupplier:"true",
      user: {
        loginid: "",
        logintype: "0",
        token: ""
      },
      checksession: true,
      timeOutTips: "",
    };
  },
  computed: {
    ...mapGetters("user", ["hrid", "language"])
  },
  mounted() {
    this.init();
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      // this.reload();
    },
    init() {
      //this.$router.go(0);
      this.getTimeOutMessage();
      this.checkSession();
      if(this.checksession){
         this.issupplier = this.$cookies.get("issupplier");
        let issupplier1 = this.issupplier;
        this.changeLang(this.language);
        if(issupplier1){
          this.query.hrid = this.hrid;
          this.query.pagesize = this.paginationConfig.pagesize.toString();
          this.query.page = this.paginationConfig.page.toString();
          this.query.status = this.searchbarOpt.filter.value;
          this.query.str = this.searchbarOpt.text;
          this.getBiddingList();
        }else{
          this.query.hrid = this.searchbarOptTwo.suppliername;
          this.query.rfqnum = this.searchbarOptTwo.tenderNo;
          //this.getBiddingList_issupplier();
        }
      } 
    },
    numFormat(row,column,cellValue){
      cellValue += '';
			if (!cellValue.includes('.')) cellValue += '.';
			return cellValue.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
				return $1 + ',';
			}).replace(/\.$/, '');
    },
    showInfo(index, type, colName) {
      let tender = this.tableData[index];
      this.tenderDetail.title.value = tender.udztbnum;
      this.tenderDetail.content.label = this.$t(`biddingList_pageText.${type}`);
      this.tenderDetail.content.value = tender[colName.toLowerCase()];
      this.visible = true;
    },
    detail(row) {
      //console.log(row);
    },
    tableHeaderCellClassName({ row, column, rowIndex, columnIndex }) {
      return "ui-table-header-cell";
    },
    tableContentCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 0) {
        return "ui-table-content-cell";
      }
    },
    changepwd(){

    },
    getList(query) {
      query.reqname = "getudztb";
      return new Promise((resolve, reject) => {
        let _this = this;
        postRequest("getList", {
          reqname: query.reqname,
          hrid: query.hrid,
          pagesize: query.pagesize,
          page: query.page,
          str: query.str,
          status: query.status
        })
          .then(res => {
            let datas = res.data;
            //console.log(datas.getudztb[0].status);
            resolve(datas);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getList_issupplier(query) {
      query.reqname = "getjlludztb";
      return new Promise((resolve, reject) => {
        let _this = this;
        postRequest("getList", {
          reqname: query.reqname,
          suppliername: query.hrid,
          rfqnum:query.rfqnum
        })
          .then(res => {
            let datas = res.data;
            resolve(datas);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getPageCount(query) {
      query.reqname = "udztbcount";
      return new Promise((resolve, reject) => {
        postRequest("getList", {
          reqname: query.reqname,
          hrid: query.hrid,
          str: query.str,
          status: query.status
        })
          .then(res => {
            let datas = res.data;
            //console.log(datas);
            resolve(datas);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getBiddingList() {
      this.loading = true;
      this.getPageCount(this.query)
        .then(res => {
          return new Promise((resolve, reject) => {
            if (res.success) {
              if (res.udztbcount.length > 0) {
                this.paginationConfig.total = parseInt(
                  res.udztbcount[0].totalcount
                );
                //console.log(res);
              } else {
                this.paginationConfig.total = 0;
              }
              resolve();
            } else {
              reject();
            }
          });
        })
        .then(() => {
          return this.getList(this.query);
        })
        .then(res => {
          this.tableData = res.getudztb;
          this.loading = false;
        })
        .catch(error => {
          this.$message.error(this.$t("warning_pageText.CONNECTFAIL"));
          this.loading = false;
        }); 
    },
    getBiddingList_issupplier() {
      this.loading = true;
      this.getList_issupplier(this.query)
        .then(res => {
          this.tableData = res.getjlludztb;
          this.loading = false;
        })
        .catch(error => {
          this.$message.error(this.$t("warning_pageText.CONNECTFAIL"));
          this.loading = false;
        });
    },
    handleCurrentChange(index) {
      this.checkSession();
      if(this.checksession){
        this.paginationConfig.page = index;
        this.query.page = index.toString();
        this.getBiddingList();
      }
    },
    handlePrevClick(index) {
      this.checkSession();
      if(this.checksession){
        this.paginationConfig.page = index;
        this.query.page = index.toString();
        this.getBiddingList();
      }
    },
    handleNextClick(index) {
      this.checkSession();
      if(this.checksession){
        this.paginationConfig.page = index;
        this.query.page = index.toString();
        this.getBiddingList();
      }
      
    },
    search(e) {
      this.checkSession();
      if(this.checksession){
        this.query.status = e.filter;
        this.query.str = e.text;
        this.query.page = "1";
        this.paginationConfig.page = 1;
        if(this.query.str){
        }else{
          this.query.str="";
        }
        this.getBiddingList();
      }
    },
    search2(){
      this.checkSession();
      if(this.checksession){
        this.query.hrid = this.searchbarOptTwo.suppliername;
        this.query.rfqnum = this.searchbarOptTwo.tenderNo;
        this.getBiddingList_issupplier();
      } 
    },
    checkSession(){
      let _this = this;
      return new Promise((resolve, reject) => {
        postRequest("checkSession", {
          hrid: _this.hrid,
          clienthost: sessionStorage.getItem('ip') ? sessionStorage.getItem('ip') : '127.0.0.1',
          maxsessionid: (!sessionStorage.getItem('maxsessionid') || sessionStorage.getItem('maxsessionid')=='')? '0' : sessionStorage.getItem('maxsessionid'),
          result: sessionStorage.getItem('sessionresult') ? sessionStorage.getItem('sessionresult') : '2',
        })
          .then(res => {
            let datas = res.data;
            //console.log(datas);
            //return;
            if(!datas.success){
              _this.checksession = false;
              sessionStorage.setItem('sessionresult','0');
              _this.$message.error({
                 message: (!sessionStorage.getItem("timeOutTips") || sessionStorage.getItem("timeOutTips")=='') ? 
                'Your session has timed out. Please log in again.' : sessionStorage.getItem("timeOutTips"),
                duration: 4000
              });
              setTimeout(function (){
                _this.logout();
              }, 3000);
            }else{
             sessionStorage.setItem('sessionresult','1');
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    logout() {
      let _this = this;
      _this.user.loginid = _this.hrid;
      _this.user.token = token;
      _this
        .logoutHandle(_this.user)
        .then(res => {
          if (res.success) {
            _this.$router.go(0);
            _this.$store.commit("user/removeUser");
            _this.$router.replace("/login?langcode=" + _this.$i18n.locale);
            
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch(error => {
          _this.$message.error(_this.$t("warning_pageText.CONNECTFAIL"));
        });
    },
    logoutHandle(user) {
      return new Promise((resolve, reject) => {
        postRequest("userLogout", {
          loginid: user.loginid,
          logintype: user.logintype,
          token: user.token,
          maxsessionid: (!sessionStorage.getItem('maxsessionid') || sessionStorage.getItem('maxsessionid')=='')? '0' : sessionStorage.getItem('maxsessionid'),
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getTimeOutMessage(){
      return postRequest("getList", {
        reqname: "getmessageutil",
        templateid: "timeout"
      })
        .then(res => {
          if (!res.data.success)
            throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
          else {
            this.timeOutTips = res.data.getmessageutil[0].message;
            sessionStorage.setItem("timeOutTips",this.timeOutTips);
            //console.log(this.timeOutTips);
          }
        })
        .catch(error => {
          throw error;
        });
    }
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.searchbarOpt.placeholder = this.$t(
        "biddingList_pageText.SEARCHPLACEHOLDER"
      );
      this.searchbarOpt.filter.filterList[0].label = this.$t(
        "biddingList_pageText.ALL"
      );
      this.searchbarOpt.filter.filterList[1].label = this.$t(
        "biddingList_pageText.WTQUOTE"
      );
      this.searchbarOpt.filter.filterList[2].label = this.$t(
        "biddingList_pageText.COMPQUQTE"
      );
      this.buttonLabel.more = this.$t("common_pageText.MORE");
      this.buttonLabel.detail = this.$t("biddingList_pageText.DETAIL");
      this.tableLabel.tenderNo = this.$t("biddingList_pageText.TENDERNO");
      this.tableLabel.description = this.$t("biddingList_pageText.DESCRIPTION");
      // this.tableLabel.supplierName = this.$t(
      //   "biddingList_pageText.SUPPLIERNAME"
      // );
      this.tableLabel.tenderType = this.$t("biddingList_pageText.TENDERTYPE");
      this.tableLabel.tenderTemplate = this.$t(
        "biddingList_pageText.TENDERTEMPLATE"
      );
      this.tableLabel.contact = this.$t("biddingList_pageText.CONTACT");
      this.tableLabel.enddate = this.$t("biddingList_pageText.ENDDATE");
      this.tableLabel.totalAmount = this.$t("biddingList_pageText.TOTALAMOUNT");
      this.tableLabel.status = this.$t("biddingList_pageText.STATUS");
      this.tenderDetail.title.label = this.$t("biddingList_pageText.TENDERNO");
    }
  }
};
</script>
<style scoped>
.ui-pagination {
  margin: 10px 0;
}
.line-word-break{
  word-break: keep-all;
  -webkit-line-clamp: 2;
}
.header{
    background: #fff;
    height: 80px;
    padding-top: 20px;
}
.profile_photo {
  display: flex;
  align-self: center;
  /* margin: auto 5px; */
}
.profile_photo > img {
  width: 54px;
  height: 54px;
  /* margin-left: 10px;
  margin-right: 10px; */
  border-radius: 50%;
  border: 3px solid #fff;
  box-sizing: border-box;
  background-color: #fff;
}
</style>

